import { Box, CircularProgress, Grid, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../../components/base/BasicDialog";
import { useGetSeller } from "../../../services/usersApi";
import { CreateEmailFooterButton } from "./CreateEmailFooterButton";
import { DeleteEmailFooterButton } from "./DeleteEmailFooterButton";
import { EditEmailFooterButton } from "./EditEmailFooterButton";

export const ManageEmailFootersDialog = (props) => {
    const { open, onClose, sellerId } = props;
    const { t } = useTranslation();

    const { data: seller, refetch } = useGetSeller(sellerId);

    const emailFooterCard = (emailFooter) => {
        return (
            <Paper sx={{ p: 1 }}>
                <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                    <Grid item sx={{ mx: 2 }}>
                        <Typography>{emailFooter.name}</Typography>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <EditEmailFooterButton
                                emailFooter={emailFooter}
                                sellerId={sellerId}
                                onSuccess={refetch}
                            />
                            <DeleteEmailFooterButton
                                emailFooterId={emailFooter.id}
                                onSuccess={refetch}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        );
    };

    return (
        <BasicDialog
            open={open}
            onClose={onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("sellers.EmailFootersManageDialog.title")}
            minWidth={200}
            maxWidth={"sm"}
            showDialogActions
        >
            <Box
                sx={{
                    mx: 10,
                }}
            >
                {!seller && <CircularProgress />}

                {seller && seller.email_footers.length === 0 && (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                        }}
                    >
                        <Typography>{t("common.noData")}</Typography>
                        <CreateEmailFooterButton sellerId={sellerId} onSuccess={refetch} />
                    </Box>
                )}

                {seller && seller.email_footers.length > 0 && (
                    <Grid container spacing={2}>
                        {seller.email_footers.map((emailFooter) => (
                            <Grid item xs={12} key={emailFooter.id}>
                                {emailFooterCard(emailFooter)}
                            </Grid>
                        ))}
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                <CreateEmailFooterButton sellerId={sellerId} onSuccess={refetch} />
                            </Box>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </BasicDialog>
    );
};
